export class createApplicationRequestDto {
  clientId: string;
  resourceId: string;
  administratorsEmails: string[];
}
